import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsHomeValueStep2FormFields } from '../../../../../@types/features/calculators';
import { IntlShape } from 'react-intl/src/types';

export type ResidenceType =
  | 'Appartement'
  | 'Tussenwoning'
  | 'Hoekwoning'
  | 'TweeOnderEinKapwoning'
  | 'VrijstaandeWoning'
  | 'Woonhuis'
  | 'Other';

export const useCalculatorHomeValueStep2FormFields = (intl: IntlShape) => {
  const r: FormInput<ResidenceType> = {
    fieldName: 'residenceType',
    label: '',
    type: 'select',
    required: true,
    options: [
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.apartment',
          defaultMessage: 'Appartement'
        }),
        value: 'Appartement'
      },
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.terracedHouse',
          defaultMessage: 'Tussenwoning'
        }),
        value: 'Tussenwoning'
      },
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.cornerHouse',
          defaultMessage: 'Hoekhuis'
        }),
        value: 'Hoekwoning'
      },
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.semiDetachedHouse',
          defaultMessage: '2 onder 1 kap'
        }),
        value: 'TweeOnderEinKapwoning'
      },
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.detachedHouse',
          defaultMessage: 'Vrijstaande woning'
        }),
        value: 'VrijstaandeWoning'
      },
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.residentialHouse',
          defaultMessage: 'Woonhuis'
        }),
        value: 'Woonhuis'
      },
      {
        label: intl.formatMessage({
          id: 'step2.residenceType.other',
          defaultMessage: 'Andere woning'
        }),
        value: 'Other'
      }
    ],
    defaultValue: getDefaultValue('Appartement')
  };

  const calculatorHomeValueStep2FormFields: Record<
    keyof CalculatorsHomeValueStep2FormFields,
    FormInput
  > = {
    residenceType: r,
    maintenance: {
      fieldName: 'maintenance',
      label: intl.formatMessage({
        id: 'step2.maintenance',
        defaultMessage: 'Staat van de woning'
      }),
      options: [
        {
          label: intl.formatMessage({
            id: 'step2.maintenance.excellent',
            defaultMessage: 'Uitstekend onderhouden'
          }),
          value: 'Excellent'
        },
        {
          label: intl.formatMessage({
            id: 'step2.maintenance.good',
            defaultMessage: 'Goed onderhouden'
          }),
          value: 'Good'
        },
        {
          label: intl.formatMessage({
            id: 'step2.maintenance.average',
            defaultMessage: 'Redelijk onderhouden'
          }),
          value: 'Average'
        },
        {
          label: intl.formatMessage({
            id: 'step2.maintenance.belowAverage',
            defaultMessage: 'Toe aan onderhoud'
          }),
          value: 'BelowAverage'
        },
        {
          label: intl.formatMessage({
            id: 'step2.maintenance.poor',
            defaultMessage: 'Slecht (direct werk nodig voor bewoonbaarheid)'
          }),
          value: 'Poor'
        }
      ],
      type: 'select',
      required: true,
      defaultValue: getDefaultValue('Excellent', true)
    },
    energyLabel: {
      fieldName: 'energyLabel',
      label: intl.formatMessage({
        id: 'step2.energyLabel',
        defaultMessage: 'Energielabel'
      }),
      type: 'select',
      required: true,
      options: [
        { label: 'A++++', value: 'APlusPlusPlusPlus' },
        { label: 'A+++', value: 'APlusPlusPlus' },
        { label: 'A++', value: 'APlusPlus' },
        { label: 'A+', value: 'APlus' },
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
        { label: 'E', value: 'E' },
        { label: 'F', value: 'F' },
        { label: 'G', value: 'G' },
        {
          label: intl.formatMessage({
            id: 'step2.energyLabel.unknown',
            defaultMessage: 'Onbekend'
          }),
          value: 'Unknown'
        }
      ],
      defaultValue: getDefaultValue('Unknown', true)
    }
  };

  return { fields: calculatorHomeValueStep2FormFields, residenceType: r };
};
